// Function to open the PPL branch selection map
function openPplBranchSelection(hiddenPoints) {
  var overlay = document.createElement('div');
  overlay.classList.add('ppl_pickup-container');

  var closeBtn = document.createElement('div');
  closeBtn.style.cssText = 'height: 35px; display: flex; flex-direction: row; justify-content: flex-end;';
  closeBtn.innerHTML = `
    <div style="width: 20px; height: 20px; margin-right: 10px; cursor: pointer;" onclick="closePplBranchSelection()">
      <svg viewBox="0 0 26 26" fill="none">
        <path d="M23.4094 1.22941C23.7636 0.88159 24.3312 0.88159 24.6855 1.22941C25.0491 1.58639 25.0491 2.17221 24.6855 2.52919L2.58549 24.2269C2.23122 24.5747 1.66364 24.5747 1.30937 24.2269C0.945776 23.8699 0.945776 23.284 1.30937 22.9271L23.4094 1.22941Z" fill="currentColor"></path>
        <path d="M0.661939 1.89106C0.298343 1.53409 0.298345 0.948263 0.661941 0.591286C1.01621 0.243465 1.58379 0.243466 1.93806 0.591286L25.3381 23.5653C25.7017 23.9223 25.7017 24.5081 25.3381 24.8651C24.9838 25.2129 24.4162 25.2129 24.0619 24.8651L0.661939 1.89106Z" fill="currentColor"></path>
      </svg>
    </div>
  `;
  overlay.appendChild(closeBtn);

  var mapDiv = document.createElement('div');
  mapDiv.id = 'ppl-parcelshop-map';
  mapDiv.setAttribute('data-country', 'cz');
  mapDiv.setAttribute('data-countries', 'cz');
  mapDiv.setAttribute('data-language', 'cs');
  mapDiv.setAttribute('data-mode', 'default');
  if (hiddenPoints) mapDiv.setAttribute('data-hiddenpoints', hiddenPoints);
  mapDiv.style.cssText = 'width: 100%; height: 100%;';
  overlay.appendChild(mapDiv);

  document.body.appendChild(overlay);

  // Load PPL map scripts
  var css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = 'https://ppl.cz/sources/map/main.css';
  document.head.appendChild(css);

  var script = document.createElement('script');
  script.src = 'https://ppl.cz/sources/map/main.js';
  script.async = true;
  document.head.appendChild(script);

  // Listen for PPL parcelshop selection event
  document.addEventListener('ppl-parcelshop-map', pplParcelshopHandler);
}

// Function to close the PPL branch selection map
function closePplBranchSelection() {
  var overlay = document.querySelector('.ppl_pickup-container');
  if (overlay) {
    overlay.remove();
  }

  // Clean up PPL scripts
  var pplScript = document.querySelector('script[src*="ppl.cz/sources/map/main.js"]');
  if (pplScript) pplScript.remove();
  var pplCss = document.querySelector('link[href*="ppl.cz/sources/map/main.css"]');
  if (pplCss) pplCss.remove();

  // Remove event listener
  document.removeEventListener('ppl-parcelshop-map', pplParcelshopHandler);
}

// Function to handle PPL parcelshop selection event
function pplParcelshopHandler(event) {
  var point = event.detail;
  if (!point) return;

  var id = point.code || point.id || point.accessPointId || '';
  var name = point.name || point.title || '';
  if (!id && !name) return;

  resetBranchPlaceholders();

  pointId = id;
  pointName = name;

  closePplBranchSelection();
  updatePplBranch(pointName);
}
